import React from 'react';
import { Battery, Signal, Wifi } from 'lucide-react';
const PHONE_WIDTH = 390;
const PHONE_HEIGHT = 844;
interface DeckPhoneFrameProps {
  children: React.ReactNode;
  /** Rendered size relative to the real 390×844 app viewport. */
  scale?: number;
  /** Screen background. Defaults to the Vexu app surface. */
  surfaceClassName?: string;
}

/**
 * Presentation-only device shell. Mirrors the chrome of the product's
 * MobileFrame (status bar, Dynamic Island, home indicator) without the
 * in-app demo console, so real screens can be shown inside deck slides.
 */
export function DeckPhoneFrame({
  children,
  scale = 0.78,
  surfaceClassName = 'app-gradient-bg-light'
}: DeckPhoneFrameProps) {
  return <div style={{
    width: PHONE_WIDTH * scale,
    height: PHONE_HEIGHT * scale
  }} className="relative" data-id="element-187" data-mp="euhrm9avk0at">
      <div style={{
      width: PHONE_WIDTH,
      height: PHONE_HEIGHT,
      transform: `scale(${scale})`,
      transformOrigin: 'top left'
    }} className="absolute top-0 left-0" data-id="element-188" data-mp="1vb3ypisp83fr">
        <div className="relative w-full h-full rounded-[46px] bg-[#e8e8e6] border-[9px] border-[#e8e8e6] ring-1 ring-black/[0.06] shadow-[0_60px_120px_-40px_rgba(12,32,22,0.35)]" data-id="element-189" data-mp="3ea47nxnqtp5s">
          <div className={`absolute inset-0 rounded-[38px] overflow-hidden ${surfaceClassName}`} data-id="element-190" data-mp="3j7mlo2gmaukn">
            {/* Status bar */}
            <div className="absolute top-0 left-0 right-0 h-12 px-6 flex items-center justify-between z-30 bg-white/60 backdrop-blur-2xl" data-id="element-191" data-mp="2qluutl8icbqs">
              <span className="text-[13px] font-semibold text-slate-900" data-id="element-192" data-mp="2vhs4x9t6glv4">
                9:41
              </span>
              <div className="flex items-center gap-1.5 text-slate-900" data-id="element-193" data-mp="34c6m5hx9q6gv">
                <Signal className="w-4 h-4" data-id="element-194" data-mp="34eaz0pd5afta" />
                <Wifi className="w-4 h-4" data-id="element-195" data-mp="27utrym49nw1y" />
                <Battery className="w-5 h-5" data-id="element-196" data-mp="27u1yphy56aeu" />
              </div>
            </div>

            {/* Dynamic Island */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[120px] h-[35px] rounded-full bg-black z-40" data-id="element-197" data-mp="2btj4kchhd9kj" />

            {/* Screen content — presentation only, never user-interactive */}
            <div className="absolute inset-0 pt-12 overflow-hidden select-none" style={{
            pointerEvents: 'none'
          }} aria-hidden="true" data-id="element-198" data-mp="3a5vrpalbgi87">
              {children}
            </div>

            {/* Home indicator */}
            <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-32 h-1 rounded-full bg-black/25 z-40" data-id="element-199" data-mp="2w8gydurxzqay" />
          </div>
        </div>
      </div>
    </div>;
}